import React from 'react';
import CircularButton from '@hero/ui-kit/inputs/CircularButton';
import ChatBubbleIcon from '../../../../components/icons/ChatBubbleIcon';
import useGetUnreadSmsCount from '../../api/useGetUnreadSmsCount';
import UnreadSmsModal from './UnreadSmsModal';
import * as Style from './style.module.scss';

const UnreadSmsHeaderButton: React.FC = () => {
    const [isOpen, setIsOpen] = React.useState(false);

    const { data } = useGetUnreadSmsCount();
    const unreadCount = data?.count ?? 0;
    const hasUnread = unreadCount > 0;

    return (
        <div className={Style.wrapper}>
            <CircularButton
                variant="secondary"
                isLink={false}
                onClick={() => setIsOpen(true)}
                marginLeft="small"
                className="flex-center"
                alt={hasUnread ? `${unreadCount} unread SMS` : 'No unread SMS'}
            >
                <ChatBubbleIcon />
            </CircularButton>
            {hasUnread ? (
                <span aria-hidden className={Style.badge}>
                    {unreadCount > 99 ? '99+' : unreadCount}
                </span>
            ) : null}
            {isOpen ? <UnreadSmsModal onClose={() => setIsOpen(false)} /> : null}
        </div>
    );
};

export default UnreadSmsHeaderButton;
